import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouteService } from 'src/app/services/routes/route.service';
import { IonInfiniteScroll, IonRefresher } from '@ionic/angular';
import { Route } from 'src/app/models/route';
import { AlertService } from 'src/app/services/alert/alert.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { Storage } from '@ionic/storage';
import { ROUTE_TYPE } from 'src/app/constants';
import { DiscoverRouteParams } from 'src/app/models/discoverRouteParams';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-find-send',
  templateUrl: './discover-send.page.html',
  styleUrls: ['./discover-send.page.scss'],
})
export class DiscoverSendPage implements OnInit, OnDestroy {
  @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonRefresher, { static: false }) refresher: IonRefresher;

  routes: Route[] = [];
  findParams: DiscoverRouteParams = {
    type: ROUTE_TYPE.send,
    offset: 0,
    limit: 10,
  };
  isLargerScreen: boolean = false;

  constructor(
    public spinner: SpinnerService,
    private auth: AuthService,
    private profileService: ProfileService,
    private routeService: RouteService,
    private router: Router
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenSizeIsLargerThen();
  }
  
  private routerSubscription: Subscription;

  unicodeMoneyWings = '&#x1F4B8;';

  ngOnInit() {
    this.screenSizeIsLargerThen();

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('/discover-send')) {
          this.ionViewWillEnter();
        }
      }
    });
  }

  ionViewWillEnter() {
    if (!this.spinner.isSpinning()){
      this.onRefresh()
      // this.fetch().then();
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  screenSizeIsLargerThen() {
    this.isLargerScreen = window.innerWidth >= 400;
  }

  async fetch() {
    try {
      await this.spinner.show();

      let token: string;
      try {
        token = (await this.profileService.getProfile()) && (await this.auth.getToken());
      } catch (err) {}

      const { body, headers } = await this.routeService.searchDiscover(token, this.findParams);

      this.routes = this.routes.concat(body);
      this.findParams.offset += body.length;
      const count = parseInt(headers.get('x-total-count'), 10);
      this.infiniteScroll.complete().then();
      this.infiniteScroll.disabled = this.routes.length >= count;
      // this.routes = body;
      // this.infiniteScroll.disabled = true;

      // if (!token) {
      //   await this.storage.set('lastUserSearch', this.router.url);
      // }

      await this.spinner.dismiss();
    } catch (err) {
      this.infiniteScroll.disabled = true;
      this.infiniteScroll.complete().then();
      this.spinner.dismissWithAlertError(err).then();
    }
  }

  onRefresh() {
    this.routes = [];
    this.findParams.offset = 0;
    this.fetch();

    this.refresher.complete().then();
  }

  public goToCarryPage() {
    this.router.navigate([`/carry`]).then();
  }
}
